import jsonp from "jsonp";

export function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

export function toBody(node) {
    document.body.appendChild(node);
}

export function toCamel(s) {
    return s.replace(/([-_][a-z])/ig, ($1) => {
        return $1.toUpperCase()
            .replace('-', '')
            .replace('_', '');
    });
}

const jsonpFetch = (url, options) => new Promise((resolve, reject) => jsonp(url, options, (err, data) => err ? reject(err) : resolve(data)));

export async function apiRequest(url, data) {
    let query = Object.keys(data)
        .map(k => encodeURIComponent(k) + '=' + encodeURIComponent(data[k]))
        .join('&');
    url += '?' + query;
    return await jsonpFetch(url);
}
